<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title font">Ayuda CVF
      <mat-icon 
      (click)="descargaAyuda()" 
      matTooltip="Descargar ayuda" 
      class="ml-2 color-custom pointer-cursor" 
      style="cursor: pointer; margin-left: 8px;">
      download
    </mat-icon>
    </h3>
    <button type="button" (click)="closeDialog()" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="zoom-controls">
    <button type="button" class="btn btn-primary" (click)="zoomOut()" >–</button>
    <button type="button" class="btn btn-primary"  (click)="zoomIn()">+</button>
    <button type="button" class="btn btn-primary" (click)="resetZoom()">⟳</button>
  </div>
  <div class="modal-body" >
    <div class="zoom-wrapper" style="display: flex; justify-content: center;">
      <div
        class="zoom-content"
        [style.transform]="'scale(' + scale + ')'"
        [style.transform-origin]="'top center'">
        <div class="fondo-ayuda" [class.fondo-ayuda-poseedor]="isPoseedor" [class.fondo-ayuda-gestor]="!isPoseedor"></div>
      </div>
    </div>
  </div>

  <div class="fixed-footer">
    <div class="modal-footer actions">
      <div class="note"></div>
      <div class="button-group">
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal"
          aria-label="Close">Volver</button>
      </div>
    </div>
  </div>

</div>